import { FC, useMemo } from "react";
import { Stack } from "@mui/material";
import {
  ForecastedCostRe,
  ForecastOption,
  WidgetNormalizedCostAggregation,
} from "@/services/cloudchipr.api";
import { ResourceExplorerForecastedCosts } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/resource-explorer-metadata/components/forecasted/ResourceExplorerForecastedCosts";
import { WidgetContentCostsCard } from "@/components/pages/dashboard/components/widgets/common/WidgetContentCostsCard";

interface NormalizedCostWidgetAggregationsProps {
  totalCost?: number;
  totalCostTrend?: number;
  forecastOption: ForecastOption;
  forecastedCosts?: ForecastedCostRe;
  averageNormalizedMonthlyCost?: number;
  aggregations: WidgetNormalizedCostAggregation;
}

export const NormalizedCostWidgetAggregations: FC<
  NormalizedCostWidgetAggregationsProps
> = ({
  totalCost,
  aggregations,
  totalCostTrend,
  forecastOption,
  forecastedCosts,
  averageNormalizedMonthlyCost,
}) => {
  const noAggregations = useMemo(
    () => Object.values(aggregations).every((aggregation) => !aggregation),
    [aggregations],
  );
  const {
    forecasted_month_end_cost,
    average_normalized_monthly_cost,
    actual_total_cost,
  } = aggregations;

  if (noAggregations) {
    return;
  }

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ overflowX: "auto", overflowY: "hidden" }}
    >
      <Stack direction="row" spacing={2}>
        {actual_total_cost && (
          <WidgetContentCostsCard
            title="Actual Total Cost"
            cost={totalCost}
            trend={totalCostTrend}
            costAlignment="start"
          />
        )}

        {average_normalized_monthly_cost && (
          <WidgetContentCostsCard
            title="Avg Normalized Monthly Cost"
            cost={averageNormalizedMonthlyCost}
            costAlignment="start"
          />
        )}
      </Stack>

      {forecasted_month_end_cost && (
        <ResourceExplorerForecastedCosts
          forecastedCosts={forecastedCosts}
          selectedForecastOption={forecastOption}
        />
      )}
    </Stack>
  );
};
